import {ApolloClient} from 'apollo-client';
import {InMemoryCache, defaultDataIdFromObject} from 'apollo-cache-inmemory';
import {ApolloLink} from 'apollo-link';
import {createHttpLink} from 'apollo-link-http';
import {onError} from 'apollo-link-error';

const CSRF_TOKEN_HEADER = 'x-csrf-token';

export default ({prefix, siteContext}) => {
    const cache = new InMemoryCache({
        dataIdFromObject: (object) => {
            switch (object.__typename) {
                case 'Badge':
                    return object.helpText;
                default:
                    return defaultDataIdFromObject(object);
            }
        },
    }).restore(window.__APOLLO_STATE__);

    const linkHeaders = {
        'client-name': 'landingapp',
        'client-version': '1.0.0',
        'x-homeaway-site': `${siteContext.name}`,
    };

    const httpLink = createHttpLink({
        uri: `${prefix}/graphql`,
        credentials: 'same-origin',
        headers: linkHeaders,
    });

    const setCsrfToken = new ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                // Adding `x-csrf-token` for XHR queries when users are logged in
                [CSRF_TOKEN_HEADER]: window.ha.csrfToken,
            },
        });

        return forward(operation).map((res) => {
            const {response} = operation.getContext();
            const csrfToken = response.headers.get(CSRF_TOKEN_HEADER);

            if (csrfToken) {
                window.ha.csrfToken = csrfToken;
            }

            return res;
        });
    });

    // This fixes the apollo's error handling misbehavior which results for us
    // in the following sentry events:
    // https://sentry.io/organizations/homeaway/issues/2033324933/?project=5336942
    // The link to the mentioned apollo issue:
    // https://github.com/apollographql/apollo-feature-requests/issues/153
    const errorLink = onError(({networkError}) => {
        if (networkError) {
            // Check if error response is a valid JSON
            try {
                JSON.parse(networkError.bodyText);
            } catch (e) {
                // If not replace parsing error message with the real one
                networkError.message = networkError.bodyText;
            }
        }
    });

    return new ApolloClient({
        ssrMode: false,
        cache,
        link: ApolloLink.from([errorLink, setCsrfToken.concat(httpLink)]),
    });
};
